import React, { useEffect, useRef, useState } from 'react';
import View from 'src/components/view';
import utils from 'src/components/utils';
import Element from 'src/components/element';

function CredencialVirtualConsultor() {
  let [view, setView] = useState({});
  let [crud, setCrud] = useState({ data: {}, changed: {} });
  let [index, setIndex] = useState(0);
  let [ready, setReady] = useState(false);
  let urlApi = utils.getUrlApi();
  let token = utils.getToken();
  let clienteLogado = utils.getCliente();
  
  let [evento, setEvento] = useState(null);
  let [consultor, setConsultor] = useState(null);
  let [isShowCredencial, setIsShowCredencial] = useState(false);
  let [listaCredenciaisConsultor, setListaCredenciaisConsultor] = useState([]);
  
  let urlCartaoCredencialCdn = 'https://storage.googleapis.com/interpennweb-storage/template/convites/especial/consultores.png';
  // const defaultBackgroundImg = urlCartaoCredencialCdn.replace("{id_evento}", "0");
  let [backgroundImg, setBackgroundImg] = useState(urlCartaoCredencialCdn);
  
  crud.onSelectConsultor = function (evt, args, x) {
    if (args.consultor && args.consultor.id) {
      consultor = args.consultor;
      setConsultor(consultor);
      validaExibicaoCard();
    }
  };

  crud.onSelectEvento = function (evt, args, x) {
    if (args.evento && args.evento.id) {
      evento = args.evento;
      setEvento(evento);
      validaExibicaoCard();
    }
  };

  const validaExibicaoCard = function () {
    isShowCredencial = (evento && evento.id > 0) && (consultor && consultor.id > 0);
    setIsShowCredencial(isShowCredencial);
    setListaCredenciaisConsultor(listaCredenciaisConsultor = []);
    if (isShowCredencial) {
      loadListaCredenciaisConsultorEvento();
    }
  };

  const loadListaCredenciaisConsultorEvento = function() {
    view.loadingStart();
    utils.execute(
      crud, "CredencialCliente?lazy=false&tipo=CREDENCIAL_CONSULTOR&evento="+evento.id+"&consultor="+consultor.id, null,
      function (res) {
        if (res.data && res.data.length > 0) {
          listaCredenciaisConsultor = res.data;
          setListaCredenciaisConsultor(listaCredenciaisConsultor);
          //updateVisualizacaoCredenciais();
          view.refresh();
        }
        view.loadingEnd();
      }
    );
  };

  crud.geraCredenciaisConsultor = function() {
    let actions = [];
    actions.push({ label: utils.lng('sim', 'Sim'), action: () => { requestGeracaoCredenciaisConsultor(true) }});
    actions.push({ label: utils.lng('nao', 'Não'), action: () => { requestGeracaoCredenciaisConsultor(false) }});
    if (window.dialog) {
      window.dialog.alert(utils.lng('deseja_enviar_credenciais_email_consultor','Deseja enviar as credencias ao consultor via e-mail?'), null, actions);
    }
  }

  const requestGeracaoCredenciaisConsultor = function(enviarEmailConsultor) {
    if (evento && evento.id > 0 && consultor && consultor.id > 0) {
      view.loadingStart();
      const req_nova_credencial_consultor = {};
      
      req_nova_credencial_consultor.crud = crud;
      req_nova_credencial_consultor.validate = false;
      // req_nova_credencial_consultor.changed = crud.data;
      // req_nova_credencial_consultor.element = {};

      req_nova_credencial_consultor.cfg = {
        url: 'geraCredencialConsultor?id_evento='+evento.id+'&id_consultor='+consultor.id+'&enviar_email='+enviarEmailConsultor,
        method: 'POST'
      };
      req_nova_credencial_consultor.complete = (res) => {
        if (res.data && res.data.length > 0) {
          listaCredenciaisConsultor = res.data;
          setListaCredenciaisConsultor(listaCredenciaisConsultor);
          //updateVisualizacaoCredenciais();
        }
        view.loadingEnd();
      };
      utils.call(req_nova_credencial_consultor);
    }
  }

  // const updateVisualizacaoCredenciais = function() {
  //   listaCredenciaisConsultor.forEach((credencial) => {
  //     document.getElementById('container_credenciais').innerHTML += credencial.templateHtml;
  //   });
  // }

  let viewCfg = {
    label: utils.lng('credencial_virtual', 'Credencial Virtual'),
    name: 'credencialVirtual',
    add: false,
    print: false,
    auto: true,
    type: 'card',
    widgetVar: 'credencialVirtual',
    elements: {
      evento: {
        type: 'select',
        name: 'evento',
        field: 'evento',
        label: utils.lng('evento', "Evento"),
        cols: 12,
        space: 12,
        list: {
          url: 'listarEventosAtivosPermitidosParaConsultores'
        },
        change: {
          action: 'onSelectEvento'
        },
        itemLabel: 'titulo'
      },
      consultor: {
        type: 'entity',
        entity: 'Cliente',
        name: 'consultor',
        field: 'consultor',
        label: utils.lng('consultor', "Consultor"),
        cols: 12,
        space: 12,
        list: {
          url: 'listarConsultoresFilhosCredencialConsultor'
        },
        change: {
          action: 'onSelectConsultor'
        }
      },
      gerar_credenciais: {
        label: utils.lng('gerar_credenciais','Gerar Credenciais'),
        type: 'button',
        disabled: !isShowCredencial,
        cols: 12,
        space: 12,
        click: {
          action: 'geraCredenciaisConsultor'
        }
      }
    }
  };

  return (
    <View name="ui-credenciais" view={view}>
      <Element value={viewCfg} crud={crud} data={crud.data} view={view} ></Element>

      <div id="container_credenciais" className="credencial-consultor-view" style={{ visibility: isShowCredencial ? 'visible' : 'hidden' }}>
        <>
          {listaCredenciaisConsultor && listaCredenciaisConsultor.length > 0 &&
            <>
              {listaCredenciaisConsultor.map((credencialConsultor, index) => (
                <div className="credencial-consultor-card">
                  <img id="img-background-credencial" className="credencial-background-img" src="https://storage.googleapis.com/interpennweb-storage/template/convites/especial/consultores.png"></img>
                  
                  <img className="credencial-consultor-qrcode" src={credencialConsultor.urlImagemQrCode} ></img>

                  <span className="credencial-field credencial-consultor-nome-consultor"> {credencialConsultor.nome} </span>
                  <span className="credencial-field credencial-consultor-nome-di"> {credencialConsultor.nomeEmpresa} </span>
                </div>
              ))}
            </>
          }
        </>
      </div>

    </View>
  );
  
}

export default CredencialVirtualConsultor;

/*
<div id="container_credenciais" ref={refContainerCredenciais} className="credencial-consultor-view">
        <div id="container_credenciais" className="credencial-consultor-layout" style={{ visibility: isShowCredencial ? 'visible' : 'hidden' }}>
        </div>
      </div> 

{listaCredenciaisConsultor && listaCredenciaisConsultor.length > 0 &&
          <>
            {listaCredenciaisConsultor.map((credencialConsultor, index) => (
              <>
                { credencialConsultor.templateHtml }
              </>
              // <div className="credencial-consultor-card">
              //   <img id="img-background-credencial" className="credencial-background-img" src="https://storage.googleapis.com/interpennweb-storage/template/convites/especial/consultores.png"></img>
                
              //   <img className="credencial-consultor-qrcode" src={credencialConsultor.urlImagemQrCode} ></img>

              //   <span className="credencial-field credencial-consultor-nome-consultor"> {credencialConsultor.nome} </span>
              //   <span className="credencial-field credencial-consultor-nome-di"> {credencialConsultor.nomeEmpresa} </span>
              // </div>

              // <div className="credencial-card" style={{ marginBottom: '30px' }}>
              //   <img id="img-background-credencial" className="credencial-background-img" src={ backgroundImg }></img>
                
              //   <img className="credencial-consultor-qrcode" 
              //     src={ 
              //       credencialConsultor.urlImagemQrCode ? credencialConsultor.urlImagemQrCode : urlApi+"/qrcode.png?access_token="+token+"&text="+(isShowCredencial && credencialConsultor ? credencialConsultor.qrCode : '')+"&width=450&height=450" 
              //     }
              //   ></img>

              //   <span className="credencial-field credencial-consultor-nome-consultor"> {credencialConsultor.nome} </span>
              //   <span className="credencial-field credencial-consultor-nome-di"> {credencialConsultor.nomeEmpresa} </span>
              // </div>
            ))}
          </>
        }

*/